import { Reactor } from 'nuclear-js';

export default new Reactor({
    /**
     * Set in .env file
     */
    debug: false,
});
